import { useEffect } from "react";

/**
 * Injects PWA + Apple "Add to Home Screen" metadata while the admin tree
 * is mounted. On unmount the tags are removed so public pages keep their
 * own (currently nonexistent) defaults and never advertise themselves as
 * the A1 Admin app.
 *
 * Render this once at the top of any admin route (AdminLogin + AdminLayout).
 */
const TAGS = [
    {
        id: "a1-admin-manifest",
        tag: "link",
        attrs: { rel: "manifest", href: "/admin-manifest.webmanifest" },
    },
    {
        id: "a1-admin-apple-icon",
        tag: "link",
        attrs: { rel: "apple-touch-icon", href: "/admin-icon.svg" },
    },
    {
        id: "a1-admin-apple-capable",
        tag: "meta",
        attrs: { name: "apple-mobile-web-app-capable", content: "yes" },
    },
    {
        id: "a1-admin-apple-bar",
        tag: "meta",
        attrs: { name: "apple-mobile-web-app-status-bar-style", content: "black-translucent" },
    },
    {
        id: "a1-admin-apple-title",
        tag: "meta",
        attrs: { name: "apple-mobile-web-app-title", content: "A1 Admin" },
    },
    {
        id: "a1-admin-mobile-capable",
        tag: "meta",
        attrs: { name: "mobile-web-app-capable", content: "yes" },
    },
];

export default function AdminPwaMeta() {
    useEffect(() => {
        TAGS.forEach(({ id, tag, attrs }) => {
            if (document.getElementById(id)) return;
            const el = document.createElement(tag);
            el.id = id;
            Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
            document.head.appendChild(el);
        });
        return () => {
            TAGS.forEach(({ id }) => {
                const el = document.getElementById(id);
                if (el) el.remove();
            });
        };
    }, []);
    return null;
}
